import React from 'react';
import { inject, observer } from 'mobx-react';

import { SectionLayout } from 'layouts/section';
import { ContactCardComponent as ContactCard } from 'components/cards';

const styles = require('./contact-page.styles.scss');


@inject('configStore', 'analyticsStore')
@observer
export class ContactPage extends React.Component {
  componentDidMount() {
    this.props.analyticsStore.pageview('/contact');
  }

  render() {
    return (
      <div className={styles.ContactPage}>
        <SectionLayout>
          <h1>Kontakt</h1>
          <p>
            Gerne helfe ich Ihnen und Ihrem Tier. Hilfreich ist eine Schilderung des problematische Verhalten des Patienten, die Umstände und die Krankengeschichte. Dafür sende ich Ihnen den entsprechenden Fragebogen zu und zeitnah wird der erste Hausbesuch verabredet.
          </p>

          <p>
            Hier können Sie mich erreichen um einen Termin zu vereinbaren oder ein Seminar zu buchen:
          </p>

          <ContactCard
            tel='+49-174-3595658'
            email='kontakt@tierverhalten.berlin'
            links={this.props.configStore.links$}
          />
        </SectionLayout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact/contact.page.jsx